if (!window.cbqCarouselTargets) {
  window.cbqCarouselTargets = (offsets, max) => offsets.map(value => Math.min(max, Math.max(0, value))).filter((value, index, values) => index === 0 || Math.abs(value - values[index - 1]) > 1);
  window.cbqSetupCarousel = root => {
    const track = root.querySelector('[data-cbq-track]');
    if (!track) return null;
    const dots = root.querySelector('[data-cbq-dots]');
    const previous = root.querySelector('[data-cbq-prev]');
    const next = root.querySelector('[data-cbq-next]');
    const abort = new AbortController();
    let positions = [], signature = '', frame = 0;
    const behavior = () => matchMedia('(prefers-reduced-motion:reduce)').matches ? 'instant' : 'smooth';
    const nearest = () => positions.reduce((best, value, index) => Math.abs(value - track.scrollLeft) < Math.abs(positions[best] - track.scrollLeft) ? index : best, 0);
    const go = index => track.scrollTo({left: positions[Math.max(0, Math.min(index, positions.length - 1))] || 0, behavior: behavior()});
    const refresh = () => {
      const max = Math.max(0, track.scrollWidth - track.clientWidth);
      const slides = [...track.children];
      positions = window.cbqCarouselTargets(slides.map(slide => slide.offsetLeft - (slides[0]?.offsetLeft || 0)), max);
      const key = positions.join(',');
      if (dots && signature !== key) {
        signature = key;
        dots.replaceChildren(...positions.map((position, index) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'cbq-dot';
          button.dataset.cbqDot = String(index);
          button.setAttribute('aria-label', root.dataset.slideLabel.replace('__index__', String(index + 1)));
          return button;
        }));
      }
      const current = nearest();
      dots?.querySelectorAll('[data-cbq-dot]').forEach((button, index) => {
        button.classList.toggle('is-active', index === current);
        button.setAttribute('aria-current', index === current ? 'true' : 'false');
      });
      if (dots) dots.hidden = positions.length < 2;
      if (previous) previous.disabled = track.scrollLeft < 2;
      if (next) next.disabled = track.scrollLeft >= max - 2;
    };
    const schedule = () => {cancelAnimationFrame(frame);frame = requestAnimationFrame(refresh);};
    track.addEventListener('scroll', schedule, {passive: true, signal: abort.signal});
    track.addEventListener('keydown', event => {
      if (event.target !== track || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
      event.preventDefault();
      go(event.key === 'Home' ? 0 : event.key === 'End' ? positions.length - 1 : nearest() + (event.key === 'ArrowRight' ? 1 : -1));
    }, {signal: abort.signal});
    dots?.addEventListener('click', event => {const button = event.target.closest('[data-cbq-dot]');if (button) go(Number(button.dataset.cbqDot));}, {signal: abort.signal});
    previous?.addEventListener('click', () => go(nearest() - 1), {signal: abort.signal});
    next?.addEventListener('click', () => go(nearest() + 1), {signal: abort.signal});
    const resize = new ResizeObserver(refresh);
    resize.observe(track);
    refresh();
    return {refresh, destroy() {abort.abort();resize.disconnect();cancelAnimationFrame(frame);}};
  };
}
if (!customElements.get('cb-product-rail')) {
  customElements.define('cb-product-rail', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.events = new AbortController();
      const signal = this.events.signal;
      this.carousel = window.cbqSetupCarousel(this);
      this.querySelectorAll('[data-cbq-open]').forEach(button => button.addEventListener('click', () => {
        const dialog = document.getElementById(button.dataset.cbqOpen);
        if (!dialog) return;
        dialog.returnFocus = button;
        this.matchCurrentModel(dialog);
        this.updateVariant(dialog);
        dialog.showModal();
      }, {signal}));
      this.querySelectorAll('[data-cbq-dialog]').forEach(dialog => {
        dialog.querySelector('[data-cbq-close]')?.addEventListener('click', () => dialog.close(), {signal});
        dialog.addEventListener('click', event => {
          if(event.target !== dialog) return;
          const rect = dialog.getBoundingClientRect();
          if(event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
        }, {signal});
        dialog.addEventListener('close', () => dialog.returnFocus?.focus(), {signal});
        dialog.querySelectorAll('[data-cbq-option]').forEach(select => select.addEventListener('change', () => this.updateVariant(dialog), {signal}));
      });
      this.querySelectorAll('.cbq-cart-form').forEach(form => form.addEventListener('submit', event => this.addToCart(event, form), {signal}));
    }
    disconnectedCallback() {this.events?.abort();this.carousel?.destroy();this.initialized = false;}
    matchCurrentModel(dialog) {
      if (this.dataset.matchModel !== 'true') return;
      const data = this.querySelector('[data-cbq-current-product]');
      const input = document.querySelector('product-info[id^="MainProduct-"] form[action*="/cart/add"] input[name="id"]');
      if (!data || !input) return;
      const variants = this.currentProductVariants || (this.currentProductVariants = JSON.parse(data.textContent));
      const current = variants.find(variant => String(variant.id) === String(input.value));
      if (!current) return;
      dialog.querySelectorAll('[data-cbq-option]').forEach(select => {
        const options = [...select.options];
        if (!options.some(option => /iphone|samsung|galaxy|pixel|oneplus/i.test(option.value))) return;
        const match = options.find(option => current.options.includes(option.value));
        if (match) select.value = match.value;
        else {
          if (!options.some(option => option.value === '')) {
            const placeholder = document.createElement('option');
            placeholder.value = '';
            placeholder.textContent = this.dataset.chooseDevice;
            placeholder.disabled = true;
            select.prepend(placeholder);
          }
          select.value = '';
        }
      });
    }
    updateVariant(dialog) {
      if (!dialog.variants) {
        const data = JSON.parse(dialog.querySelector('[data-cbq-variants]').textContent);
        if (Array.isArray(data)) dialog.variants = data;
        else {
          const money = new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency:data.currency});
          dialog.variants = data.ids.map((id, index) => ({id,options:data.options[index],available:data.available[index],price:money.format(data.prices[index]/100),image:(typeof data.images[index] === 'string' ? data.images[index] : data.images[index]?.src) || data.fallback_image}));
        }
      }
      const variants = dialog.variants;
      const values = [...dialog.querySelectorAll('[data-cbq-option]')].map(select => select.value);
      const variant = variants.find(item => item.options.every((value, index) => value === values[index]));
      const form = dialog.querySelector('form');
      form.querySelector('[name=id]').value = variant?.id || '';
      form.querySelector('[type=submit]').disabled = !variant?.available;
      dialog.querySelector('[data-cbq-submit-label]').textContent = variant ? (variant.available ? this.dataset.add : this.dataset.soldOut) : this.dataset.unavailable;
      if (variant) {
        dialog.querySelector('[data-cbq-variant-price]').textContent = variant.price;
        if (variant.image) dialog.querySelector('[data-cbq-variant-image]').src = variant.image;
      }
      const status = form.querySelector('.cbq-form-status');
      status.hidden = true;
      status.textContent = '';
    }
    async addToCart(event, form) {
      event.preventDefault();
      const button = form.querySelector('[type=submit]');
      if (button.disabled || form.dataset.cbqPending === 'true') return;
      const status = form.querySelector('.cbq-form-status');
      const label = button.querySelector('span');
      const oldLabel = label.textContent;
      const body = new FormData(form);
      const controls = [...form.querySelectorAll('select, input[name=quantity]')].map(control => ({control, disabled: control.disabled}));
      form.dataset.cbqPending = 'true';
      controls.forEach(({control}) => {control.disabled = true;});
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      status.hidden = true;
      const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      if (cart?.getSectionsToRender) {
        body.append('sections', cart.getSectionsToRender().map(section => section.id).join(','));
        body.append('sections_url', location.pathname);
        cart.setActiveElement?.(form.closest('dialog')?.returnFocus || document.activeElement);
      }
      try {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(root + 'cart/add.js', {method: 'POST', body, headers: {'X-Requested-With': 'XMLHttpRequest'}});
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(result.description || this.dataset.error);
        if (cart?.renderContents) {
          form.closest('dialog')?.close();
          cart.classList.remove('is-empty');
          cart.renderContents(result);
        } else {location.assign(root + 'cart');}
        status.textContent = this.dataset.added;
        status.hidden = false;
        label.textContent = this.dataset.added;
        window.setTimeout(() => {if (label.textContent === this.dataset.added) label.textContent = oldLabel;}, 1600);
      } catch (error) {
        status.textContent = error.message || this.dataset.error;
        status.hidden = false;
      } finally {
        controls.forEach(({control, disabled}) => {control.disabled = disabled;});
        form.dataset.cbqPending = 'false';
        button.disabled = false;
        button.removeAttribute('aria-busy');
      }
    }
  });
}
if (!window.cbqMotionInitialized) {
  window.cbqMotionInitialized = true;
  const reduced = matchMedia('(prefers-reduced-motion:reduce)');
  const initMotion = scope => {
    (scope || document).querySelectorAll('[data-cbq-motion]:not([data-cbq-ready])').forEach(root => {
      root.dataset.cbqReady = 'true';
      root.cbqCarousel = window.cbqSetupCarousel(root);
      const videos = [...root.querySelectorAll('.cbq-motion-video')];
      const visible = new Set();
      const sync = () => videos.forEach(video => {
        if (visible.has(video) && !reduced.matches && !document.hidden) video.play().catch(() => {});
        else video.pause();
      });
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {if (entry.intersectionRatio >= .6) visible.add(entry.target);else visible.delete(entry.target);});
        sync();
      }, {threshold: [0, .6]});
      videos.forEach(video => observer.observe(video));
      document.addEventListener('visibilitychange', sync);
      reduced.addEventListener('change', sync);
      root.cbqDestroy = () => {
        root.cbqCarousel?.destroy();
        observer.disconnect();
        document.removeEventListener('visibilitychange', sync);
        reduced.removeEventListener('change', sync);
        videos.forEach(video => video.pause());
        delete root.dataset.cbqReady;
      };
    });
  };
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initMotion());else initMotion();
  document.addEventListener('shopify:section:load', event => initMotion(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-cbq-motion]').forEach(root => root.cbqDestroy?.()));
}
